import React, { useState, useEffect } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useSelector } from 'react-redux';
import { useGetInterviewCandDetailsQuery } from '../../../../../features/hiringstages/interviewApiSlice';
import { selectCandidateInterview } from '../../../../../features/hiringstages/candidateInterviewSlice';
import { getPresignedUrl } from '../../../../../components/common/getPresignedUrl';

function CandResume({fileName}) {
  // // const candId = useSelector(selectCandidateInterview);
  // const {
  //   data: canddetails,
  //   isLoading,
  //   isSuccess,
  // } = useGetInterviewCandDetailsQuery(candId, {
  //   refetchOnMountOrArgChange: true,
  // });
  // console.log('candId = ', canddetails);
  // Create new plugin instance
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  // const fileName = canddetails?.data.fileName
  console.log('resume = ', fileName);

  // resume = '/resume/static-resume.pdf'

  //PDFjs worker from an external cdn
  // const url =
  //   `https://cors-anywhere.herokuapp.com/${resume}`
  // pdfjs.GlobalWorkerOptions.workerSrc =
  //   `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  // const [numPages, setNumPages] = useState(null);
  // const [pageNumber, setPageNumber] = useState(1);

  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages);
  //   setPageNumber(1);
  // }
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  

 useEffect(() => {
    async function fetchPdf() {
      setLoading(true);
      const url = await getPresignedUrl(fileName);
      setPdfUrl(url);
      setLoading(false);
    }

    fetchPdf();
  }, [fileName]);


  return (
    <>
      <div style={{ marginTop: "20px", height: "500px" }}>
        {loading ? (
          <p>Loading PDF...</p>
        ) : pdfUrl ? (
          <iframe src={pdfUrl} width="100%" height="100%" style={{ border: "none" }} />
        ) : (
          <p style={{ color: "red", textAlign: "center", backgroundColor: "whitesmoke" }}>
            ❌ No file found
          </p>
        )}
      </div>
    </>
  );
}

export default CandResume;
